module.exports = __webpack_public_path__ + "img/icon_person.83ed6b87.svg";